
import axios from "axios";
// import Swal from "sweetalert2";
export const createEmployeeResign = async (employeeId, description, paymentOption, status, selectedDate, setLoading) => {
  try {
      if (typeof setLoading !== 'function') {
          console.warn('setLoading is not a function, skipping loading state update');
      } else {
          setLoading(true);
      }

      const response = await axios.post("/employee-resign", {
          employee: employeeId,
          description: description,
          status: status,
          resignDate: selectedDate,
          paymentOption: paymentOption,
      });

      if (typeof setLoading === 'function') {
          setLoading(false);
      }

      console.log('Employee resignation created successfully:', response.data);
      return response.data;
  } catch (error) {
      if (typeof setLoading === 'function') {
          setLoading(false);
      }
      console.error('Failed to create employee resignation:', error.response ? error.response.data : error.message);
      throw error;
  }
};
  export const getResignationsByEmployeeId = async (employeeId) => {
    try {
      const response = await axios.get(`/employee-resign/${employeeId}`);
     // console.log("Resignation records fetched successfully:", response.data);
      return response.data;
    } catch (error) {
      if (error.response) {
        console.error("Error fetching resignation records:", error.response.data.message);
      } else {
        console.error("Error:", error.message);
      }
      throw error;
    }
  };

// Reactivate employee
export const reactivateEmployee = async (employeeId, resignationId, reactivationDate, reactivationReason, remarks, setLoading) => {
  try {
    if (typeof setLoading === 'function') {
      setLoading(true);
    }

    const response = await axios.post("/employee-reactivate", {
      employeeId,
      resignationId,
      reactivationDate,
      reactivationReason,
      remarks
    });

    if (typeof setLoading === 'function') {
      setLoading(false);
    }

    console.log('Employee reactivated successfully:', response.data);
    return response.data;
  } catch (error) {
    if (typeof setLoading === 'function') {
      setLoading(false);
    }
    console.error('Failed to reactivate employee:', error.response ? error.response.data : error.message);
    throw error;
  }
};

// Get reactivation records by employee ID
export const getReactivationsByEmployeeId = async (employeeId) => {
  try {
    const response = await axios.get(`/employee-reactivations/${employeeId}`);
    console.log("Reactivation records fetched successfully:", response.data);
    return response.data;
  } catch (error) {
    if (error.response) {
      console.error("Error fetching reactivation records:", error.response.data.message);
    } else {
      console.error("Error:", error.message);
    }
    throw error;
  }
};

// Get all reactivation records
export const getAllReactivations = async () => {
  try {
    const response = await axios.get("/employee-reactivations");
    console.log("All reactivation records fetched successfully:", response.data);
    return response.data;
  } catch (error) {
    if (error.response) {
      console.error("Error fetching all reactivation records:", error.response.data.message);
    } else {
      console.error("Error:", error.message);
    }
    throw error;
  }
};
  